<script lang="ts" setup>
import type { PromoCta } from '#core/types'

const items = [
  'Input your preferences and listing strategy',
  'Receive competitive proposals from market makers',
  'Review and compare quotes alongside historical performance',
  'Select the best proposals, and engage with up to 6 participants',
  'Close negotiations, and start KPI monitoring',
]

const ctas: PromoCta[] = [
  { label: 'Create an RFQ', to: '/engage-a-market-maker/request-for-quotations' },
  { label: 'Watch the 2-Minute Demo', variant: 'outline', icon: 'play', videoUrl: 'https://www.youtube.com/watch?v=1A1iARCWSqc' },
]
</script>

<template>
  <CorePromoBanner
    intro="How it works:"
    ordered
    :items="items"
    :ctas="ctas"
    image="/images/home/promo-mm.webp"
  >
    <template #heading>
      Secure the best market maker deals in just 7 days. <span class="text-accent block">
        Full transparency. Zero cost.
      </span>
    </template>
  </CorePromoBanner>
</template>
